import { fontWeight, bodyContent } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const Strong = styled.strong `
  ${fontWeight('semibold')}
`;
export const Copy = styled.p `
  ${bodyContent};
  margin-top: 0;
`;
